/** Framed surface shared by Intranet Redaktion, Module and Bautagesbericht. */
export const intranetPanelClassName =
  'rounded-xl border border-border bg-card p-4 text-card-foreground shadow-sm';

/** Same frame without inner padding, for tables and divide-y lists. */
export const intranetTableFrameClassName =
  'overflow-x-auto rounded-xl border border-border bg-card text-card-foreground shadow-sm';
